import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { roleHome } from "@/lib/roles";
import Landing from "@/pages/Landing";

// "/" is the marketing landing page for guests, but a signed-in user has no
// use for it — send them to their dashboard instead.
export default function HomeRoute() {
  const { user, hintedRole } = useAuth();

  // Auth resolved: roleHome falls back to "/" for a guest or an unrecognised
  // role, and redirecting there would loop — those get the landing page.
  const home = roleHome(user);
  if (user && home !== "/") return <Navigate to={home} replace />;

  // Still resolving (user === null). Session cookies are httpOnly, so /auth/me
  // is the only way to know — but waiting for it would show a returning user
  // the marketing page for a whole round trip. Act on the remembered role
  // instead. If the session has since expired, the dashboard's ProtectedRoute
  // sends them to /login and the failed /auth/me clears the hint, so a stale
  // hint self-corrects after one load.
  if (user === null) {
    const hinted = roleHome({ role: hintedRole });
    if (hinted !== "/") return <Navigate to={hinted} replace />;
  }

  // Guests, and the prerender pass (scripts/prerender.js leaves auth unresolved
  // and has no hint) — so the "/" snapshot still ships full landing markup.
  return <Landing />;
}
